import { combineReducers } from "redux";
import zakatReducer from "./zakatReducer";
import homepageReducer from './homepageReducer';
import userReducer from './userReducer';
import zakatCalcReducer from "./zakatCalcReducer";
import fidyahReducer from "./fidyah-slice";
import kaffarahReducer from "./kaffarah-slice";
import donationWidgetReducer from './donationWidgetSlice';
import pledgeReducer from './pledgeReducer';
import aiChatbotSlice from './aichatbotSlice';

const rootReducer = combineReducers({
    zakatReducer,
    zakatCalcReducer,
    homepageReducer,
    userReducer,
    fidyahReducer,
    kaffarahReducer,
    donationWidgetReducer,
    pledgeReducer,
    aiChatbotSlice
})

export default rootReducer;